import { Trans, useTranslation } from "react-i18next";

export default function IntroStep() {
  const { t } = useTranslation();

  return (
    <>
      <h1>{t("Start.getStarted")}</h1>

      <p>{t("Start.welcome")}</p>

      <p
        dangerouslySetInnerHTML={{
          __html: t("Start.uniqueURL")
        }}
      />

      <p>{t("Start.onceReady")}</p>

      <p className="muted">
        <Trans i18nKey="Start.freeSetup">
          <a href="/setup" />
        </Trans>
      </p>
    </>
  );
}
